@if (_data.call) {
    <div class="flex flex-col gap-4 items-start relative h-full" [ngClass]="{'xl:flex-row': !_commonService.isPanelOpen(), 'flex-col': _commonService.isPanelOpen()}">
        <!-- Floating Sidebar Card -->
        <aside class="w-full bg-white dark:bg-surface-2 rounded-[40px] p-4 shadow-[0_8px_30px_rgb(0,0,0,0.02)] border border-white/50 dark:border-white/5 sticky top-0 shrink-0 transition-all duration-300"
               [ngClass]="{
                 '2xl:w-[410px]': !_commonService.isPanelOpen(),
                 'w-full': _commonService.isPanelOpen(),
                 '[@media(max-height:620px)]:p-3': true
               }">
            <!-- Sidebar Header -->
            <div class="flex items-center justify-between mb-4">
                <button (click)="closeDialog()" 
                        class="2xl:w-12 w-8 2xl:h-12 h-8 rounded-[18px] bg-white dark:bg-surface-0 hover:bg-slate-50 dark:hover:bg-white/5 flex items-center justify-center transition-all border border-slate-100/50 dark:border-white/10 active:scale-95 group shadow-sm cursor-pointer">
                    <app-icon-v2 name="arrowLeft" [size]="isSmallScreen() ? 16 : 20" class="text-slate-900 dark:text-white"></app-icon-v2>
                </button>
                <span class="2xl:px-5 px-2 2xl:py-2 py-1 text-white 2xl:text-[13px] text-[11px] font-bold rounded-full shadow-lg"
                      [ngClass]="productConfig().chatbotTheme?.accentBg || 'bg-blue-600'"
                      [style.boxShadow]="'0 10px 15px -3px ' + (productConfig().chatbotTheme?.markdownStrong || '#3b82f6') + '33'">
                    {{ _data.call.productName || 'Product' }}
                </span>
            </div>

            <!-- Company & Customer Info -->
            <div class="mb-4 [@media(max-height:620px)]:mb-2 space-y-4 [@media(max-height:620px)]:space-y-2">
                <div class="space-y-1">
                    <h2 class="2xl:text-[18px] text-[16px] font-semibold text-[#141437] dark:text-white">
                        {{ _data.customerDetails.name || 'Customer Name' }}
                    </h2>
                    <p class="2xl:text-[15px] text-[13px] text-slate-400 dark:text-slate-400 font-medium">
                        {{ _data.customerDetails.email || 'N.A' }}
                    </p>
                </div>
            </div>

            <!-- Agents Section -->
            <div class="2xl:py-4 py-2 border-t border-slate-100/50 dark:border-white/10">
                <h3 class="2xl:text-[13px] text-[11px] font-bold text-slate-400 dark:text-white uppercase tracking-[0.1em] mb-3 font-mono">Agents</h3>
                <div class="flex items-center gap-4 group">
                    <div class="2xl:w-12 w-8 2xl:h-12 h-8 rounded-full bg-[#141437] flex items-center justify-center text-white font-bold text-base shadow-lg shadow-slate-200 dark:shadow-none">
                        {{ getInitials(_data.agentDetails.name || 'A') }}
                    </div>
                    <div>
                        <p class="2xl:text-[16px] text-[14px] font-bold text-[#141437] dark:text-white group-hover:text-blue-400 transition-colors">
                            {{ _data.agentDetails.name || 'Agent' }}
                        </p>
                        <p class="2xl:text-[14px] text-[12px] text-slate-400 dark:text-slate-400 font-medium">
                            {{ _data.agentDetails.email || 'N.A' }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Last Activity -->
            <div class="2xl:pt-4 pt-2 border-t border-slate-100/50 dark:border-white/10">
                <h3 class="2xl:text-[13px] text-[11px] font-bold text-slate-400 dark:text-white uppercase tracking-[0.1em] mb-3 font-mono">Last Activity</h3>
                <div class="flex items-center gap-3 text-[#141437] dark:text-white">
                    <div class="flex p-2.5 rounded-xl bg-slate-50 dark:bg-surface-0 border border-slate-100/50 dark:border-white/5">
                        <app-icon-v2 name="clock" [size]="isSmallScreen() ? 16 : 20" class="text-slate-500 dark:text-slate-400"></app-icon-v2>
                    </div>
                    <span class="2xl:text-[16px] text-[14px] font-bold">
                        {{ _data.call.lastDate | date:'MMMM d, yyyy' }} at {{ _data.call.lastTime | date:'h:mm a' }}
                    </span>
                </div>
            </div>
        </aside>

        <!-- Main Content (Secondary Card) -->
        <main class="flex-1 w-full bg-white dark:bg-surface-2 rounded-[40px] shadow-[0_8px_30px_rgb(0,0,0,0.02)] border border-white/50 dark:border-white/5 overflow-hidden flex flex-col h-full transition-colors duration-300" 
              #scrollArea (scroll)="handleScroll($event)">
            
            <!-- Content Container -->
            <div class="2xl:p-6 p-4 flex-1 flex flex-col min-h-0">
                <!-- Breadcrumbs & Navigation -->
                <div class="flex flex-col gap-4 mb-4">
                    <nav class="flex items-center gap-3 2xl:text-[14px] text-[12px] font-bold tracking-tight">
                        <button (click)="backToList()" 
                                [class.text-blue-500]="selectedRecording() && !productConfig().chatbotTheme?.markdownStrong"
                                [style.color]="selectedRecording() ? productConfig().chatbotTheme?.markdownStrong : ''"
                                [class.text-slate-900]="!selectedRecording()"
                                class="hover:text-blue-500 dark:text-white/60 dark:hover:text-white transition-colors cursor-pointer">Call Recordings</button>
                        @if (selectedRecording()) {
                            <app-icon-v2 name="chevronRight" [size]="16" class="text-slate-300 dark:text-slate-700"></app-icon-v2>
                            <span class="text-slate-400 dark:text-slate-400">Details</span>
                        }
                    </nav>

                    <!-- Tab Pills (only shown on list view) -->
                    @if (!selectedRecording()) {
                        <div class="p-1.5 rounded-[22px] w-fit">
                            <app-toggle-btns 
                                [headerOptions]="tabToggleOptions()" 
                                [activeValue]="activeTab()" 
                                (viewChanged)="onTabChange($event)">
                            </app-toggle-btns>
                        </div>
                    }
                </div>

                <!-- Scrollable Content Area -->
                <div class="flex-1 overflow-y-auto pr-2 custom-scrollbar">
                    @if (activeTab() === 'GOOGLE_MEET' && !selectedRecording()) {
                        <div class="space-y-4 [@media(max-height:620px)]:space-y-2">
                            <div class="flex items-center justify-between mb-4">
                                <h2 class="2xl:text-[28px] text-[24px] font-bold text-[#141437] dark:text-white">Call History</h2>
                            </div>

                            <div class="grid grid-cols-1 gap-4">
                                @for (recording of googleMeetSessions(); track $index) {
                                    <div class="bg-white dark:bg-surface-0/40 rounded-[24px] border border-slate-100 dark:border-white/5 overflow-hidden hover:shadow-xl transition-all duration-500 group">
                                        <!-- Top Section -->
                                        <div class="p-5 flex items-center justify-between">
                                            <div class="flex items-center 2xl:gap-5 gap-3">
                                                <div class="2xl:w-12 w-8 2xl:h-12 h-8 rounded-2xl bg-slate-50 dark:bg-white/5 flex items-center justify-center text-slate-400 dark:text-slate-500">
                                                    <app-icon-v2 name="headset" [size]="isSmallScreen() ? 16 : 22"></app-icon-v2>
                                                </div>
                                                <div class="space-y-1">
                                                    <h3 class="2xl:text-[16px] text-[14px] font-bold text-[#141437] dark:text-white truncate max-w-[200px] sm:max-w-[400px]">
                                                        {{ recording.meetLink }}
                                                    </h3>
                                                    <div class="2xl:text-[13px] text-[11px] text-slate-400 dark:text-slate-500 font-medium">
                                                        {{ recording.createdAt | date:'MMM d, yyyy • hh:mm:ss a' }}
                                                    </div>
                                                </div>
                                            </div>
                                            <button (click)="selectRecording(recording)" class="bg-[#A446FF] text-white 2xl:px-6 px-4 2xl:py-2.5 py-2 rounded-xl 2xl:text-[14px] text-[12px] font-bold hover:bg-[#9235FF] transition-all shadow-lg shadow-purple-900/10 cursor-pointer">
                                                View Details
                                            </button>
                                        </div>

                                        <!-- Bottom Section -->
                                        <div class="2xl:px-5 px-4 2xl:py-4 py-2 bg-slate-50/50 dark:bg-white/5 flex items-center justify-between border-t border-slate-100 dark:border-white/5">
                                            <div class="flex items-center gap-2 2xl:text-[14px] text-[12px]">
                                                <span class="text-slate-400 dark:text-slate-500">Agents:</span>
                                                <span class="font-bold text-[#141437] dark:text-white">{{ recording.agents }}</span>
                                            </div>
                                            <div class="flex items-center 2xl:gap-6 gap-4">
                                                <div class="2xl:w-10 w-8 2xl:h-10 h-8 rounded-full bg-purple-50 dark:bg-purple-950/20 flex items-center justify-center text-[#A446FF] border border-purple-100 dark:border-purple-800/30 group-hover:bg-[#A446FF] group-hover:text-white transition-all cursor-pointer"
                                                     (click)="playRecording(recording); $event.stopPropagation()">
                                                    <app-icon-v2 name="play" [size]="isSmallScreen() ? 16 : 22" class="ml-0.5"></app-icon-v2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                } @empty {
                                    <div class="flex flex-col items-center justify-center py-16 text-slate-400 dark:text-slate-500 bg-slate-50/50 dark:bg-white/5 rounded-3xl border-2 border-dashed border-slate-100 dark:border-white/5">
                                        <div class="w-16 h-16 rounded-2xl bg-white dark:bg-slate-800 flex items-center justify-center shadow-sm mb-4">
                                            <app-icon-v2 name="video" [size]="32" class="opacity-50"></app-icon-v2>
                                        </div>
                                        <h3 class="text-lg font-bold text-slate-900 dark:text-white mb-1">No recordings found</h3>
                                        <p class="text-sm max-w-[280px] text-center">Google Meet sessions will appear here once they are recorded and available.</p>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    @if (activeTab() === 'AI_ASSISTANT') {
                        <div class="h-full rounded-3xl overflow-hidden border border-slate-100 dark:border-white/5">
                            <app-call-transcription 
                                class="h-full block"
                                [messages]="chatMessages()"
                                [isChatView]="true"
                                [productName]="_data.call?.productName || ''">
                            </app-call-transcription>
                        </div>
                    }

                    @if (selectedRecording()) {
                        <div class="space-y-5 [@media(max-height:620px)]:space-y-3 animate-in fade-in slide-in-from-right-8 duration-700">
                            <!-- Enhanced Transcription Area -->
                            <div class="space-y-4 [@media(max-height:620px)]:space-y-2">
                                <app-call-transcription 
                                    [messages]="activePlayingCall()?.formattedTranscript || []"
                                    [meetingUrl]="selectedRecording()?.meetLink || ''"
                                    [dateTime]="activePlayingCall()?.callType?.dateTime || ($safeNavigationMigration(selectedRecording()?.createdAt) | date:'MMM d, yyyy • hh:mm a')"
                                    [agents]="selectedRecording()?.agents || ''"
                                    [isPlaying]="isPlaying()"
                                    [isMuted]="isMuted()"
                                    [currentTime]="currentTime()"
                                    [audioDuration]="audioDuration()"
                                    [activeTranscriptIndex]="activeTranscriptIndex()"
                                    [productName]="_data.call?.productName || ''"
                                    (togglePlay)="togglePlay()"
                                    (toggleMute)="toggleMute()"
                                    (stopPlayback)="togglePlay()"
                                    (seek)="seekFromPercentage($event)">
                                </app-call-transcription>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <!-- Overlay Loader -->
            @if (isLoading()) {
                <div class="absolute inset-0 bg-white/60 dark:bg-surface-2/60 backdrop-blur-md z-30 flex items-center justify-center">
                    <div class="flex flex-col items-center gap-6 scale-110">
                        <div class="2xl:w-16 w-12 2xl:h-16 h-12 border-[5px] border-slate-100 dark:border-white/10 border-t-blue-500 rounded-full animate-spin shadow-inner"></div>
                        <p class="2xl:text-[15px] text-[12px] font-bold text-[#141437] dark:text-white tracking-tight">Syncing call data...</p>
                    </div>
                </div>
            }
        </main>
    </div>
} @else {
    <div class="2xl:w-16 w-12 2xl:h-16 h-12 border-[5px] border-white/30 border-t-blue-500 rounded-full animate-spin shadow-2xl"></div>
}

<ng-template #audioRecording>
  <div
    class="2xl:w-[420px] w-[320px] max-w-[calc(100vw-40px)] bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-slate-100 dark:border-slate-800 overflow-hidden animate-in fade-in slide-in-from-bottom-5 duration-300">

    <!-- Player Header -->
    <div class="2xl:px-7 px-4 2xl:pt-7 pt-4 2xl:pb-5 pb-2 flex items-start justify-between">
      <div class="flex items-center gap-4">
        <div
          class="2xl:w-11 w-8 2xl:h-11 h-8 shrink-0 rounded-2xl bg-purple-50 dark:bg-purple-900/20 flex items-center justify-center text-purple-600 dark:text-purple-400">
          <app-icon-v2 name="Headphones" [size]="isSmallScreen() ? 16 : 22"></app-icon-v2>
        </div>
        <div>
          <h3 class="font-bold text-slate-800 dark:text-white 2xl:text-[17px] text-[14px] leading-tight">{{
            activePlayingCall()?.business?.name || 'Call Recording' }}</h3>
          <div class="flex items-center gap-2 mt-1.5">
            <span class="2xl:text-[12px] text-[10px] font-semibold text-slate-400 dark:text-slate-500">{{
              activePlayingCall()?.callType?.dateTime || '' }}</span>
            <span class="w-1 h-1 rounded-full bg-slate-200 dark:bg-slate-700"></span>
            <span class="2xl:text-[12px] text-[10px] font-bold text-purple-600 dark:text-purple-400">{{
              activePlayingCall()?.callType?.platform || 'Voice' }}</span>
          </div>
        </div>
      </div>
    <button (click)="$event.stopPropagation(); closePlayer()"
        class="flex p-1.5 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-lg text-slate-300 dark:text-slate-500 transition-colors cursor-pointer">
        <app-icon-v2 name="X" [size]="20"></app-icon-v2>
      </button>
    </div>

    <!-- Player Controls -->
    <div class="2xl:px-7 px-4 2xl:py-6 py-4">
      <div class="flex items-center gap-5">
        <button (click)="$event.stopPropagation(); togglePlay()"
          class="2xl:w-12 2xl:h-12 w-10 h-10 shrink-0 flex items-center justify-center rounded-2xl bg-purple-600 text-white shadow-lg shadow-purple-600/30 hover:bg-purple-700 active:scale-95 transition-all cursor-pointer">
          <app-icon-v2 [name]="isPlaying() ? 'Pause' : 'Play'" [size]="isSmallScreen() ? 16 : 22" customClass="fill-current"></app-icon-v2>
        </button>
        <div class="flex items-center gap-2 w-full">
        <div class="h-6 flex items-center relative group cursor-pointer w-full" (click)="$event.stopPropagation(); seek($event)">
            <div class="flex-1 h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full relative">
                <!-- Seeker Thumb -->
                <div class="absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-purple-600 bg-white rounded-full -ml-1.5 transition-all duration-300 z-10 shadow-sm"
                    [style.left.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
                </div>
                <!-- Filled Track -->
                <div class="absolute inset-y-0 left-0 bg-purple-500 rounded-full transition-all duration-300"
                    [style.width.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
              </div>
            </div>
        </div>
        <div class="flex items-center justify-between 2xl:text-[11px] text-[9px] font-bold tabular-nums text-slate-400 dark:text-slate-500 uppercase tracking-wider font-mono">
            <div class="flex items-center gap-1 text-purple-600 dark:text-white">
              <span>{{ formatTime(currentTime()) }}</span>
              <span class="text-slate-400 dark:text-slate-500 px-0.5">/</span>
              <span>{{ formatTime(audioDuration()) }}</span>
            </div>
        </div>
        <button (click)="$event.stopPropagation(); toggleMute()" class="flex text-slate-400 dark:text-slate-500 hover:text-purple-600 transition-colors ml-2 cursor-pointer">
          <app-icon-v2 [name]="isMuted() ? 'volumeX' : 'volume2'" [size]="isSmallScreen() ? 16 : 20"></app-icon-v2>
        </button>
        </div>
      </div>
    </div>

    <!-- Transcript Section -->
    <div class="relative">
      <div #transcriptContainer (scroll)="onTranscriptScroll($event)"
        class="max-h-[280px] overflow-y-auto 2xl:px-7 px-4 2xl:pb-8 pb-4 space-y-0 scrollbar-hide scroll-smooth">
        @for (msg of activePlayingCall()?.formattedTranscript; track $index) {
        <div
          class="transcript-segment px-3 py-4 transition-all duration-300 border-b border-slate-100 dark:border-white/5 relative"
          [ngClass]="{ 
            'bg-purple-50 dark:bg-purple-900/10 shadow-sm': activeTranscriptIndex() === $index,
            'bg-indigo-50/30 dark:bg-indigo-950/10': msg.role === 'AGENT' && activeTranscriptIndex() !== $index
          }">
          @if (activeTranscriptIndex() === $index) {
          <div class="absolute left-0 top-0 bottom-0 w-1 bg-purple-500 rounded-full"></div>
          }
          <div class="flex items-center gap-2 mb-1.5">
            <span class="text-[14px] font-bold" 
              [class.text-purple-600]="msg.role === 'AI'" [class.dark:text-purple-400]="msg.role === 'AI'"
              [class.text-indigo-600]="msg.role === 'AGENT'" [class.dark:text-indigo-400]="msg.role === 'AGENT'"
              [class.text-blue-600]="msg.role === 'CUSTOMER'" [class.dark:text-blue-400]="msg.role === 'CUSTOMER'"
              [class.text-slate-900]="!['AI', 'AGENT', 'CUSTOMER'].includes(msg.role)" [class.dark:text-white]="!['AI', 'AGENT', 'CUSTOMER'].includes(msg.role)">
              {{ msg.sender || msg.role }}
            </span>
            <span class="2xl:text-[11px] text-[9px] font-bold text-slate-400 dark:text-slate-500 tabular-nums">[{{ msg.formattedTime ||
              '0:00' }}]</span>
          </div>
          <p class="2xl:text-[14px] text-[12px] leading-relaxed text-slate-600 dark:text-slate-400 font-medium whitespace-pre-wrap">
            {{ msg.text }}
          </p>
        </div>
        } @empty {
        <div class="py-10 [@media(max-height:620px)]:py-5 flex flex-col items-center text-center opacity-30 select-none">
          <app-icon-v2 name="FileText" [size]="32" customClass="mb-2"></app-icon-v2>
          <p class="text-sm font-bold">No transcription data found</p>
        </div>
        }
      </div>
      @if (!isAutoScrolling()) {
      <div
        class="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 transition-all duration-300 animate-in fade-in slide-in-from-bottom-2">
        <button (click)="resumeAutoScroll()"
          class="2xl:px-4 px-2 2xl:py-2 py-1 bg-purple-600 hover:bg-purple-700 text-white 2xl:text-[12px] text-[10px] font-bold rounded-full shadow-[0_4px_12px_rgba(147,51,234,0.3)] flex items-center gap-2 group transition-all transform hover:-translate-y-0.5 active:scale-95 cursor-pointer">
          <app-icon-v2 [name]="scrollDirection() === 'up' ? 'ArrowUp' : 'ArrowDown'" [size]="14" customClass="group-hover:animate-bounce"></app-icon-v2>
          Go to current transcript
        </button>
      </div>
      }
    </div>
  </div>
</ng-template>